"use client";
import { useTranslations } from "next-intl";
import { useCallback } from "react";

import { setVolume } from "../state/actions";
import { useSoundboard } from "../state/reducer";

export const VolumePanel = () => {
  const { state, dispatch } = useSoundboard();
  const t = useTranslations("ClientKeys.soundboard");

  const handleVolumeChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const volume = parseFloat(e.target.value);
      dispatch(setVolume({ volume }));
    },
    [dispatch],
  );

  return (
    <div className='sb-display-panel flex h-full flex-col items-center gap-16 rounded-md p-12'>
      {/* Volume slider container */}
      <div className='relative mt-4 w-12 flex-grow'>
        {/* Vertical slider */}
        <div
          className='sb-inactive-track pointer-events-none'
          style={{ "--volume": `${state.volume * 100}%` } as React.CSSProperties}
        />
        <input
          className='sb-volume-slider'
          max='1'
          min='0'
          onChange={handleVolumeChange}
          step='0.01'
          style={{ "--volume": `${state.volume * 100}%` } as React.CSSProperties}
          type='range'
          value={state.volume}
        />
      </div>

      <span className='font-soundboard text-xs font-semibold uppercase text-inverse'>{t("volume")}</span>
    </div>
  );
};
